import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment as config } from "../../../../environments/environment";
import { BaseService } from "../base.service";
import { UtilsService } from "../utils/utils.service";

@Injectable({
  providedIn: 'root'
})
export class VouchersService extends BaseService {
  prefixURL = 'vouchers'
  constructor(public override http: HttpClient, public utilsService: UtilsService) {
    super(http, utilsService);
    this.apiURL = config.gogarage_api;
    this.isRequiredToken = true;
  }

  checkVoucher(data: any) {
    return this.post(`${this.prefixURL}/check-voucher-code`, data);
  }
}
